// Preact Signals
import { computed, signal } from "@preact/signals-react";

// Common signals
import { userDatasets, userTemplates } from "../../Common/Store/CommonSignals";

// Tile Layout
export const tileLayoutItems = signal([]);

// Tile TreeView Configurations - stores TreeView instances per tile
// Format: {
//   [tileId]: {
//     treeViews: [
//       { id: "tv_1", name: "New TreeView 1", type: "favorites" | "myTemplates" | "custom", treeItemIds: [], itemOrder: [] },
//       ...
//     ]
//   }
// }
export const tileTreeViewConfigs = signal({});

// Dialog
export const showTileDialog = signal(false);
export const tileDialogMode = signal("add");
export const editingTile = signal(null);
export const showDeleteTileDialog = signal(false);
export const tileToDelete = signal(null);
export const showTileConfigDialog = signal(false);
export const configuringTileId = signal(null);

// TreeView Config Menu
export const showTreeViewConfigMenu = signal(false);
export const configuringTreeViewId = signal(null);
export const treeViewMenuAnchor = signal(null);

// Loading
export const isLoading = signal(true);

// Dashboard
export const currentDashboardId = signal(null);
export const dashboardName = signal("Homepage Dashboard");
export const isEditingName = signal(false);

// TreeView drag enabled state per treeView (format: { [treeViewId]: boolean })
export const treeViewDragEnabled = signal({});

// Tab management - each tab has its own isLocked state
export const selectedTabIndex = signal(0);
export const dashboardTabs = signal([
  { id: null, name: "Homepage Dashboard", tiles: [], treeViewConfigs: {}, isLocked: true },
]);

// Dashboard deletion dialog
export const showDeleteDashboardDialog = signal(false);
export const dashboardToDelete = signal(null);

// Unique tags from all templates and datasets the user has access to
export const uniqueTemplateTags = computed(() => {
  const tagsSet = new Set();

  // Collect tags from templates
  userTemplates.value?.forEach((template) => {
    const tags = template.properties?.Tags || [];
    tags.forEach((tag) => {
      if (tag && tag.trim() !== "") {
        tagsSet.add(tag.trim());
      }
    });
  });

  // Collect tags from datasets
  userDatasets.value?.forEach((dataset) => {
    const tags = dataset.tags || [];
    tags.forEach((tag) => {
      if (tag && tag.trim() !== "") {
        tagsSet.add(tag.trim());
      }
    });
  });

  return Array.from(tagsSet).sort((a, b) => a.localeCompare(b));
});
